// extracted by mini-css-extract-plugin
export default {"fanter_select":"Select_fanter_select__0YNcL"};